import { render, staticRenderFns } from "./AppVersions.vue?vue&type=template&id=113dc525&scoped=true&"
import script from "./AppVersions.vue?vue&type=script&lang=js&"
export * from "./AppVersions.vue?vue&type=script&lang=js&"
import style0 from "./AppVersions.vue?vue&type=style&index=0&id=113dc525&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113dc525",
  null
  
)

export default component.exports